import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const AboutComponent = lazy(() => import('components/Sections/About'))
const Footer = lazy(() => import('components/Layout/Footer'))

function About() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <AboutComponent />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default About